export interface Token {
  access_token: string
  expires_at: number
  profile: {
    sub: string
    'https://cinch.co.uk/user_id': string
  }
}

export interface TokenConfiguration {
  authKey: string
}

const tokenIsInDate = (token: Token): boolean =>
  token.expires_at > Date.now() / 1000

const isToken = (maybeToken: unknown): maybeToken is Token =>
  Object.prototype.hasOwnProperty.call(maybeToken, 'expires_at')

export const getToken = ({ authKey }: TokenConfiguration) => {
  if (typeof window === 'undefined') return

  const authToken = JSON.parse(localStorage.getItem(authKey) ?? '{}')

  if (isToken(authToken) && tokenIsInDate(authToken)) {
    return authToken
  }

  return null
}
